var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 8.86913H4C2.897 8.86913 2 9.76613 2 10.8691V20.8691C2 21.9721 2.897 22.8691 4 22.8691H14C15.103 22.8691 16 21.9721 16 20.8691V10.8691C16 9.76613 15.103 8.86913 14 8.86913Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 2.86913H10C9.46957 2.86913 8.96086 3.07984 8.58579 3.45491C8.21071 3.82998 8 4.33869 8 4.86913V6.86913H16C16.5304 6.86913 17.0391 7.07984 17.4142 7.45491C17.7893 7.82998 18 8.33869 18 8.86913V16.8691H20C20.5304 16.8691 21.0391 16.6584 21.4142 16.2833C21.7893 15.9083 22 15.3996 22 14.8691V4.86913C22 4.33869 21.7893 3.82998 21.4142 3.45491C21.0391 3.07984 20.5304 2.86913 20 2.86913Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.e22235d69a69b854b15d073d78f62829.svg";
export { ForwardRef as ReactComponent };